<template lang="pug">
    v-card.deal-tab-card.rounded-card(style='width:95%;' flat)
        // 標題
        v-row.mt-4.account-info(no-gutters='no-gutters' align="center")
            div.ml-11()
                h4.f-text-highlight-word() {{ $t("KB_AND_BOT_PERMISSION_SETTING.PERMISSION_SETTING") }}
            div.ml-4.pa-0.pb-2()
                div
                    v-icon.mr-1(size='18' color="green" v-if='isEdit && !loading' @click='confirmEditDetail()') icon-check
                    v-icon(size='18' color="red" v-if='isEdit && !loading' @click='cancelEditDetail()') mdi-window-close
                    v-progress-circular(size='18' v-if='loading' indeterminate color='primary')
                    v-icon(size='18' v-if='!isEdit && !loading' v-hide-element @click='onEdit()') icon-edit
        v-form(v-model='valid' ref='form')
            v-row.account-info(no-gutters='no-gutters' align="start")
                // 設定管理員(左側)
                v-col(cols='6' md='6')
                    .knowledges-detail-card-text.pt-0.pb-3
                        v-card-text.mt-0.pa-0.knowledges-card-text()
                            // 啟用權限設定
                            v-row(no-gutters).mt-2
                                v-col.pr-md-4(cols='2').my-1
                                    label(style='color:#444444; font-weight: 700; font-size: 14px;') {{$t('KB_AND_BOT_PERMISSION_SETTING.MANAGER')}} 
                                v-col.pa-0(cols='9')
                                    v-radio-group.ma-0.pa-0(v-model='default_manager_access_option' row mandatory dense :hide-details='true' :readonly='!isEdit && !loading' @change='toggleManagerAccessOption')
                                        v-radio(:label=`$t('KB_AND_BOT_PERMISSION_SETTING.ONLY_SYSTEM_ADMIN')` color='#14C6DE' :value='true')
                                        v-radio(:label=`$t('KB_AND_BOT_PERMISSION_SETTING.CUSTOM_SETTING')` color='#14C6DE' :value='false')
                            // Add User
                            v-row(no-gutters).mt-2.mb-4
                                v-col.pr-md-4(cols='2').my-1
                                    label(style='color:#444444; font-weight: 700; font-size: 14px;')
                                v-col.pa-0(cols='9')
                                    v-card.rounded-card.scrollselect
                                        v-select.bg-white.pa-0.pl-2(
                                            placeholder="Add User",
                                            v-model='MUData',
                                            return-object,
                                            multiple,
                                            chips,
                                            hide-details,
                                            :readonly="(!isEdit && !loading) || default_manager_access_option",
                                            :items='user_list',
                                            item-value='id',
                                            item-text='name',
                                        )
                                            //- @change="handleAllChange_MU"
                                            template(v-slot:prepend-inner)
                                                v-img(src="@/assets/images/user_icon.png" height="20" width="20" style="margin-top:6px;")
                                            // 全選/全取消
                                            template(v-slot:prepend-item)
                                                v-list-item(ripple @mousedown.prevent @click="toggle('MU')")
                                                    v-list-item-action
                                                        v-icon(:color="user_list.length > 0 ? '#14C6DE' : ''") {{ icon(MUData, user_list) }}
                                                    v-list-item-content
                                                        v-list-item-title {{ $t('GENERAL.SELECTALL') }}
                                                v-divider(class="mt-2")
                                            template(v-slot:selection="{ item, index, select, remove }")
                                                v-chip.permission-instance-chip.ellipsis-single(:key="index" :title='item.name')
                                                    span.ellipsis-single {{ item.name }}
                            // Add Group
                            v-row(no-gutters).mt-2.mb-6
                                v-col.pr-md-4(cols='2').my-1
                                    label(style='color:#444444; font-weight: 700; font-size: 14px;')
                                v-col.pa-0(cols='9')
                                    v-card.rounded-card.scrollselect
                                        v-select.bg-white.pa-0.pl-2(
                                            placeholder="Add Group",
                                            v-model='MGData',
                                            return-object,
                                            multiple,
                                            chips,
                                            hide-details,
                                            :readonly="(!isEdit && !loading) || default_manager_access_option",
                                            :items='upgpt_group_list',
                                            item-value='id',
                                            item-text='name',
                                        )
                                            //- @change="handleAllChange_MG"
                                            template(v-slot:prepend-inner)
                                                v-img(src="@/assets/images/group_icon.png" height="20" width="20" style="margin-top:6px;")
                                            // 全選/全取消
                                            template(v-slot:prepend-item)
                                                v-list-item(ripple @mousedown.prevent @click="toggle('MG')")
                                                    v-list-item-action
                                                        v-icon(:color="upgpt_group_list.length > 0 ? '#14C6DE' : ''") {{ icon(MGData, upgpt_group_list) }}
                                                    v-list-item-content
                                                        v-list-item-title {{ $t('GENERAL.SELECTALL') }}
                                                v-divider(class="mt-2")
                                            template(v-slot:selection="{ item, index, select, remove }")
                                                v-chip.permission-instance-chip.ellipsis-single(:key="index" :title='item.name')
                                                    span.ellipsis-single {{ item.name }}
                // 設定查看者(右側)
                v-col(cols='6' md='6')
                    .knowledges-detail-card-text.pt-0.pb-3
                        v-card-text.mt-0.pa-0.knowledges-card-text()
                            // 啟用權限設定
                            v-row(no-gutters).mt-2
                                v-col.pr-md-4(cols='2').my-1
                                    label(style='color:#444444; font-weight: 700; font-size: 14px;') {{$t('KB_AND_BOT_PERMISSION_SETTING.VIEWER')}}
                                v-col.pa-0(cols='9')
                                    v-radio-group.ma-0.pa-0(v-model='default_viewer_access_option' row mandatory dense :hide-details='true' :readonly='!isEdit && !loading' @change='toggleViewerAccessOption')
                                        v-radio(:label=`$t('KB_AND_BOT_PERMISSION_SETTING.ALL_USER')` color='#14C6DE' :value='true')
                                        v-radio(:label=`$t('KB_AND_BOT_PERMISSION_SETTING.CUSTOM_SETTING')` color='#14C6DE' :value='false')
                            // Add User
                            v-row(no-gutters).mt-2.mb-4
                                v-col.pr-md-4(cols='2').my-1
                                    label(style='color:#444444; font-weight: 700; font-size: 14px;')
                                v-col.pa-0(cols='9')
                                    v-card.rounded-card.scrollselect
                                        v-select.bg-white.pa-0.pl-2(
                                            placeholder="Add User",
                                            v-model='VUData',
                                            return-object,
                                            multiple,
                                            chips,
                                            hide-details,
                                            :readonly="(!isEdit && !loading) || default_viewer_access_option",
                                            :items='user_list',
                                            item-value='id',
                                            item-text='name',
                                        )
                                            //- @change="handleAllChange_VU"
                                            template(v-slot:prepend-inner)
                                                v-img(src="@/assets/images/user_icon.png" height="20" width="20" style="margin-top:6px;")
                                            // 全選/全取消
                                            template(v-slot:prepend-item)
                                                v-list-item(ripple @mousedown.prevent @click="toggle('VU')")
                                                    v-list-item-action
                                                        v-icon(:color="user_list.length > 0 ? '#14C6DE' : ''") {{ icon(VUData, user_list) }}
                                                    v-list-item-content
                                                        v-list-item-title {{ $t('GENERAL.SELECTALL') }}
                                                v-divider(class="mt-2")
                                            template(v-slot:selection="{ item, index, select, remove }")
                                                v-chip.permission-instance-chip.ellipsis-single(:key="index" :title='item.name')
                                                    span.ellipsis-single {{ item.name }}
                            // Add Group
                            v-row(no-gutters).mt-2.mb-6
                                v-col.pr-md-4(cols='2').my-1
                                    label(style='color:#444444; font-weight: 700; font-size: 14px;')
                                v-col.pa-0(cols='9')
                                    v-card.rounded-card.scrollselect
                                        v-select.bg-white.pa-0.pl-2(
                                            placeholder="Add Group",
                                            v-model='VGData',
                                            return-object,
                                            multiple,
                                            chips,
                                            hide-details,
                                            :readonly="(!isEdit && !loading) || default_viewer_access_option",
                                            :items='upgpt_group_list',
                                            item-value='id',
                                            item-text='name',
                                        )
                                            //- @change="handleAllChange_VG"
                                            template(v-slot:prepend-inner)
                                                v-img(src="@/assets/images/group_icon.png" height="20" width="20" style="margin-top:6px;")
                                            // 全選/全取消
                                            template(v-slot:prepend-item)
                                                v-list-item(ripple @mousedown.prevent @click="toggle('VG')")
                                                    v-list-item-action
                                                        v-icon(:color="upgpt_group_list.length > 0 ? '#14C6DE' : ''") {{ icon(VGData, upgpt_group_list) }}
                                                    v-list-item-content
                                                        v-list-item-title {{ $t('GENERAL.SELECTALL') }}
                                                v-divider(class="mt-2")
                                            template(v-slot:selection="{ item, index, select, remove }")
                                                v-chip.permission-instance-chip.ellipsis-single(:key="index" :title='item.name')
                                                    span.ellipsis-single {{ item.name }}  
                                      
        v-dialog(v-model='successDialog' width='360' content-class='statusDialog' @keydown.enter='onEmitSuccessDialog(true)')
            success-dialog(@emitSuccessDialog='onEmitSuccessDialog')
        v-dialog(v-model='errorDialog' width='360' content-class='statusDialog')
            error-dialog(@emitErrorDialog='onEmitErrorDialog' :errorMessage='errorMessage')
        v-dialog(v-model='messageDialog' width='360' content-class='statusDialog')
            message-dialog(@emitMessageDialog='onEmitMessageDialog' :message='message')
</template>
<script>
	import Vue from 'vue';
    // import i18n from '/common/plugins/vue-i18n.js';
    import successDialog from "@/components/Dialog/successDialog";
    import errorDialog from "@/components/Dialog/errorDialog";
    import messageDialog from '@/components/Dialog/messageDialog';
    import PersonalSettingService from "@/services/PersonalSettingService";
    import PermissionService from "@/services/PermissionService";
    import KnowledgeLibraryService from "@/services/KnowledgeLibraryService";
    import AiBotsService from "@/services/AiBotsService";

	export default Vue.extend({
        props: {
            instance_id: {
                type: String,
                required: true,
            },
            model_type: {
                type: String,
                required: true,
            },
        },
        components: {
            successDialog,
            errorDialog,
            messageDialog,
        },
        data() {
		return {
            valid:false,
            isEdit:false,
            loading:false,
            //- Data
            user_list:[],
            upgpt_group_list:[],
            default_manager_access_option:true,
            default_viewer_access_option:true,
            MUData:[],
            MGData:[],
            VUData:[],
            VGData:[],
            // //- 每次更動的比對值
            com_manager_access_option:true,
            com_viewer_access_option:true,
            compareMUData:[],
            compareMGData:[],
            compareVUData:[],
            compareVGData:[],
            // //- 取消更新時的復原值
            ori_manager_access_option:true,
            ori_viewer_access_option:true,
            originalMUData:[],
            originalMGData:[],
            originalVUData:[],
            originalVGData:[],
            //- Dialog
            successDialog:false,
            errorDialog:false,
            errorMessage:"",
            messageDialog:false,
            message:"",
        }},
        async created()
        {
            this.loading = true;
            await this.getUserListData();
            await this.getUpGPTGroupListData();
            await this.getPermissionData();
            this.loading = false;
        },
        methods:{
            validateForm(){
                this.valid = this.$refs.form.validate();
                if(this.valid)
                    return true;
                else
                    return false;
            },
            async getUserListData(){
                await PersonalSettingService.getUpGPTUserDetail().then(response => {
                    if (response.data.userList.length > 0) {
                        let temp_arr = [];// [{"id":0, "name": i18n.t('GENERAL.ALL')}];
                        let temp_data = {};
                        let user_data = response.data.userList;
                        user_data.filter(el => {
                            temp_data = {};
                            if(el.is_active == true){
                                temp_data['id'] = el.id;
                                temp_data['name'] = el.last_name+' '+el.first_name;
                                temp_arr.push(temp_data);
                            }
                        });
                        // 下拉選單依名稱 A-Z 排序（不分大小寫）
                        temp_arr.sort((a, b) => a.name.localeCompare(b.name, 'en', { sensitivity: 'base' }));
                        this.user_list = temp_arr
                    }
                }).catch((response) => {
                    this.showErrorDialog(response);
                });
            },
            async getUpGPTGroupListData(){
                await PermissionService.getUpGPTGroups().then(response => {   
                    let temp_group_list = [];// [{"id":0, "name": i18n.t('GENERAL.ALL')}];
                    if (response.data.length > 0) {
                        let temp_datas = response.data;
                        for(let index in temp_datas){
                            if((temp_datas[index]['permission_type'] == "UPGPT")){
                                temp_group_list.push(temp_datas[index])
                            }
                        }
                    }
                    temp_group_list.sort((a, b) => a.name.localeCompare(b.name, 'en', { sensitivity: 'base' }));
                    for(let index in temp_group_list){
                        this.upgpt_group_list.push(temp_group_list[index])
                    }
                }).catch((response) => {
                    this.showErrorDialog(response);
                });
            },
            async getPermissionData(){
                if(this.model_type == "KNOWLEDGE"){
                    let data = {
                        "knowledge_id":this.instance_id,
                    }
                    await KnowledgeLibraryService.getKBPermissions(data).then(response => {
                        let permissions = response.data;
                        let only_admin_user_manager = permissions['only_admin_user_manager']
                        let only_admin_group_manager = permissions['only_admin_group_manager']
                        let all_allow_user_viewer = permissions['all_allow_user_viewer']
                        let all_allow_group_viewer = permissions['all_allow_group_viewer']
                        if (only_admin_user_manager && only_admin_group_manager)
                            this.default_manager_access_option = true;
                        else
                            this.default_manager_access_option = false;
                        if (all_allow_user_viewer && all_allow_group_viewer)
                            this.default_viewer_access_option = true;
                        else
                            this.default_viewer_access_option = false;
                        this.MUData = permissions['user_managers'];
                        this.MGData = permissions['group_managers'];
                        this.VUData = permissions['user_viewers'];
                        this.VGData = permissions['group_viewers'];
                    }).catch((response) => {
                        this.showErrorDialog(response);
                    });
                }else if(this.model_type == "BOT"){
                    let data = {
                        "bot_id":this.instance_id,
                    }
                    await AiBotsService.getBOTPermissions(data).then(response => {
                        let permissions = response.data;
                        let only_admin_user_manager = permissions['only_admin_user_manager']
                        let only_admin_group_manager = permissions['only_admin_group_manager']
                        let all_allow_user_viewer = permissions['all_allow_user_viewer']
                        let all_allow_group_viewer = permissions['all_allow_group_viewer']
                        if (only_admin_user_manager && only_admin_group_manager)
                            this.default_manager_access_option = true;
                        else
                            this.default_manager_access_option = false;
                        if (all_allow_user_viewer && all_allow_group_viewer)
                            this.default_viewer_access_option = true;
                        else
                            this.default_viewer_access_option = false;
                        this.MUData = permissions['user_managers'];
                        this.MGData = permissions['group_managers'];
                        this.VUData = permissions['user_viewers'];
                        this.VGData = permissions['group_viewers'];
                    }).catch((response) => {
                        this.showErrorDialog(response);
                    });
                }
            },
            toggle(type) {
                this.$nextTick(() => {
                    if(type == "MU"){
                        if (this.checkAll(this.MUData, this.user_list)) {
                            this.MUData = []
                        } else {
                            this.MUData = this.user_list.slice()
                        }
                    }else if(type == "MG"){
                        if (this.checkAll(this.MGData, this.upgpt_group_list)) {
                            this.MGData = []
                        } else {
                            this.MGData = this.upgpt_group_list.slice()
                        }
                    }else if(type == "VU"){
                        if (this.checkAll(this.VUData, this.user_list)) {
                            this.VUData = []
                        } else {
                            this.VUData = this.user_list.slice()
                        }
                    }else if(type == "VG"){
                        if (this.checkAll(this.VGData, this.upgpt_group_list)) {
                            this.VGData = []
                        } else {
                            this.VGData = this.upgpt_group_list.slice()
                        }
                    }
                })
            },
            checkAll(selected_option, option_list){
                return selected_option.length === option_list.length
            },
            checksome(selected_option, option_list){
                return selected_option.length > 0 && !this.checkAll(selected_option, option_list)
            },
            icon(selected_option, option_list){
                if (this.checkAll(selected_option, option_list)){
                    return 'mdi-close-box'
                }else if(this.checksome(selected_option, option_list)){
                     return 'mdi-minus-box'
                }else{
                    return 'mdi-checkbox-blank-outline'
                }
            },
            onEdit(){
                this.isEdit = true;
                this.ori_manager_access_option = JSON.parse(JSON.stringify(this.default_manager_access_option));
                this.ori_viewer_access_option = JSON.parse(JSON.stringify(this.default_viewer_access_option));
                this.originalMUData = JSON.parse(JSON.stringify(this.MUData));
                this.originalMGData = JSON.parse(JSON.stringify(this.MGData));
                this.originalVUData = JSON.parse(JSON.stringify(this.VUData));
                this.originalVGData = JSON.parse(JSON.stringify(this.VGData));
                // this.compareMUData = this.originalMUData;
                // this.compareMGData = this.originalMGData;
                // this.compareVUData = this.originalVUData;
                // this.compareVGData = this.originalVGData;
            },
            toggleManagerAccessOption(){
                if(this.default_manager_access_option){
                    this.MUData = [];
                    this.MGData = [];
                }
            },
            toggleViewerAccessOption(){
                if(this.default_viewer_access_option){
                    this.VUData = [];
                    this.VGData = [];
                }
            },
            handleAllChange_MU(new_selected) {
                let newIds = new_selected.map(i => i.id);
                let oldIds = this.compareMUData.map(i => i.id);
                let action = "";
                if (new_selected.some(item => !oldIds.includes(item.id))){
                    action = "add";
                }else if (this.compareMUData.some(item => !newIds.includes(item.id))){
                    action = "delete";
                }
                if (action == "add"){
                    let added_options = newIds.filter(id => !oldIds.includes(id))
                    // 如果選了 ALL，移除其他
                    if (added_options[0] === 0) {
                        this.MUData = [new_selected.find(item => item.id === 0)];
                    }else{ // 如果已選 ALL，又選其他，則移除 ALL
                        this.MUData = new_selected.filter(item => item.id !== 0);
                    }
                }
                this.compareMUData = JSON.parse(JSON.stringify(this.MUData));
            },
            handleAllChange_MG(new_selected) {
                let newIds = new_selected.map(i => i.id);
                let oldIds = this.compareMGData.map(i => i.id);
                let action = "";
                if (new_selected.some(item => !oldIds.includes(item.id))){
                    action = "add";
                }else if (this.compareMGData.some(item => !newIds.includes(item.id))){
                    action = "delete";
                }
                if (action == "add"){
                    let added_options = newIds.filter(id => !oldIds.includes(id))
                    // 如果選了 ALL，移除其他
                    if (added_options[0] === 0) {
                        this.MGData = [new_selected.find(item => item.id === 0)];
                    }else{ // 如果已選 ALL，又選其他，則移除 ALL
                        this.MGData = new_selected.filter(item => item.id !== 0);
                    }
                }
                this.compareMGData = JSON.parse(JSON.stringify(this.MGData));
            },
            handleAllChange_VU(new_selected) {
                let newIds = new_selected.map(i => i.id);
                let oldIds = this.compareVUData.map(i => i.id);
                let action = "";
                if (new_selected.some(item => !oldIds.includes(item.id))){
                    action = "add";
                }else if (this.compareVUData.some(item => !newIds.includes(item.id))){
                    action = "delete";
                }
                if (action == "add"){
                    let added_options = newIds.filter(id => !oldIds.includes(id))
                    // 如果選了 ALL，移除其他
                    if (added_options[0] === 0) {
                        this.VUData = [new_selected.find(item => item.id === 0)];
                    }else{ // 如果已選 ALL，又選其他，則移除 ALL
                        this.VUData = new_selected.filter(item => item.id !== 0);
                    }
                }
                this.compareVUData = JSON.parse(JSON.stringify(this.VUData));
            },
            handleAllChange_VG(new_selected) {
                let newIds = new_selected.map(i => i.id);
                let oldIds = this.compareVGData.map(i => i.id);
                let action = "";
                if (new_selected.some(item => !oldIds.includes(item.id))){
                    action = "add";
                }else if (this.compareVGData.some(item => !newIds.includes(item.id))){
                    action = "delete";
                }
                if (action == "add"){
                    let added_options = newIds.filter(id => !oldIds.includes(id))
                    // 如果選了 ALL，移除其他
                    if (added_options[0] === 0) {
                        this.VGData = [new_selected.find(item => item.id === 0)];
                    }else{ // 如果已選 ALL，又選其他，則移除 ALL
                        this.VGData = new_selected.filter(item => item.id !== 0);
                    }
                }
                this.compareVGData = JSON.parse(JSON.stringify(this.VGData));
            },
            async confirmEditDetail(){
                if (this.validateForm() && this.isEdit){
                    if(this.model_type == "KNOWLEDGE"){
                        let data = {
                            "knowledge_id":this.instance_id,
                            "only_admin_user_manager":this.default_manager_access_option,
                            "only_admin_group_manager":this.default_manager_access_option,
                            "user_managers":this.MUData,
                            "group_managers":this.MGData,
                            "all_allow_user_viewer":this.default_viewer_access_option,
                            "all_allow_group_viewer":this.default_viewer_access_option,
                            "user_viewers":this.VUData,
                            "group_viewers":this.VGData,
                        }
                        await KnowledgeLibraryService.changeKBPermissions(data).catch((response) => {
                            this.showErrorDialog(response);
                        });
                    }else if(this.model_type == "BOT"){
                        let data = {
                            "bot_id":this.instance_id,
                            "only_admin_user_manager":this.default_manager_access_option,
                            "only_admin_group_manager":this.default_manager_access_option,
                            "user_managers":this.MUData,
                            "group_managers":this.MGData,
                            "all_allow_user_viewer":this.default_viewer_access_option,
                            "all_allow_group_viewer":this.default_viewer_access_option,
                            "user_viewers":this.VUData,
                            "group_viewers":this.VGData,
                        }
                        await AiBotsService.changeBOTPermissions(data).catch((response) => {
                            this.showErrorDialog(response);
                        });
                    }
                }
                await this.getPermissionData();
                this.isEdit = false;
            },
            cancelEditDetail(){
                this.isEdit = false;
                this.default_manager_access_option = this.ori_manager_access_option;
                this.default_viewer_access_option = this.ori_viewer_access_option;
                this.MUData = this.originalMUData;
                this.MGData = this.originalMGData;
                this.VUData = this.originalVUData;
                this.VGData = this.originalVGData;
            },
            showSuccessDialog() {
                this.successDialog = true;
            },
            onEmitSuccessDialog() {
                this.successDialog = false;
             },
            showErrorDialog(message) {
                this.errorDialog = true;
                this.errorMessage = message;
            },
            onEmitErrorDialog() {
                this.errorDialog = false;
            },
            showMessageDialog(message) {
                this.messageDialog = true;
                this.message = message;
            },
            onEmitMessageDialog() {
                this.messageDialog = false;
            },          
        },
        watch:{
        },
        computed:{
        }
	});
</script>
<style>
    .scrollselect{
        max-height: 90px !important;
        overflow-y: auto !important;
        overflow-x: hidden !important;
        border: 1px solid #747474d0 !important;
        box-shadow: 0 0px 0px rgba(0,0,0,0) !important;
    }
    .scrollselect::-webkit-scrollbar {
        width: 6px; /* 調整滾動條寬度 */
    }
    .scrollselect::-webkit-scrollbar-track {
        background:  white !important;
    }
    .scrollselect::-webkit-scrollbar-thumb {
        background: rgba(139, 139, 139, 0.308);
        border-radius: 10px;
    }
    .permission-instance-chip {
        color: #666666 !important;
        font-family: 'Segoe UI','SegoeUI','Noto Sans TC', sans-serif !important;
        font-size: 14px !important;
        font-weight: 400 !important;
        max-width: 100px !important;
    }
    .ellipsis-single {
        display: -webkit-box;
        -webkit-line-clamp: 1; /* 部分舊版瀏覽器需要此設定 */
        line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
    }
</style>